import { useState } from 'react'
import { useDebounce } from 'use-debounce'

export const useSearchBiblioteca = () => {
  const [searchText, setSearchText] = useState('')

  const [searchDebounce] = useDebounce(searchText, 150)

  const isSearching = searchDebounce !== ''

  return {
    searchText,
    setSearchText,
    searchDebounce,
    isSearching
  }
}
